import { TInquiriesDetailsData } from "@/interfaces";

const OfficialGazetteInquiryDetails = ({
  data,
}: {
  data: TInquiriesDetailsData;
}) => {
  return <div>InquiryDetails</div>;
};

export default OfficialGazetteInquiryDetails;
